import React, { useEffect, useState } from "react";
import { Modal, ConfigProvider, Divider, Image, Spin } from "antd";
import ApiService from "../../utils/ApiService";
import useUserStore from "../../stores/store";
import useScrollLock from "../../hooks/useScrollLock";
function ViewCategoryModal({ isViewModalOpen, setIsViewModalOpen, record }) {
  const [upsertLoading, setUpsertLoading] = useState(false);
  const { user, restaurantId } = useUserStore();
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [variants, setVariants] = useState([]);

  // Lock scroll when modal is open
  useScrollLock(isViewModalOpen);

  const handleOk = () => {
    setIsViewModalOpen(false);
  };
  const handleCancel = () => {
    setIsViewModalOpen(false);
  };
  const viewCategoryDetails = async (categoryId, restaurantId) => {
    setUpsertLoading(true);
    const token = user.token.token;
    try {
      const response = await ApiService.GET_SPECIFIC_CATEGORY_DETAILS({ categoryId, restaurantId }, token);

      if (response?.payload?.record) {
        setCategoryDetails(response.payload.record);

        // filter variants and set it
        setVariants(filterSystemDefault(response.payload.record.options));
      } else {
        console.error("Failed to fetch category details: ", response);
      }
    } catch (error) {
      console.error("Error fetching category details: ", error);
    } finally {
      setUpsertLoading(false);
    }
  };

  useEffect(() => {
    viewCategoryDetails(record.id, restaurantId);
  }, [record.id]);

  const filterSystemDefault = (items) => items.filter((item) => item.name !== "System Default");

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        open={isViewModalOpen}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col font-uregular">
          <div className="ant-modal-title">Category Details</div>
          <Divider />
          {upsertLoading ? (
            <div className="h-[30vh] flex items-center justify-center">
              <Spin size="large" />
            </div>
          ) : (
            <div className="space-y-4">
              {/* Category Name */}
              <div>
                <div className="font-ubold">Name: </div>
                <div>{categoryDetails?.name || "N/A"}</div>
              </div>

              {/* Category Image */}
              <div>
                <div className="font-ubold">Category Image: </div>
                {categoryDetails?.image ? (
                  <Image
                    src={categoryDetails.image}
                    alt="Category"
                    width={100}
                    height={100}
                    className={"border"}
                    style={{ borderRadius: "8px", marginTop: "8px" }}
                  />
                ) : (
                  <span>No Image</span>
                )}
              </div>

              {/* Options / Variants */}
              {variants?.length > 0 && (
                <div>
                  <span className="font-ubold block mb-2">Variants:</span>
                    <div className="space-y-2">
                      {variants.map((opt, index) => (
                        <div key={opt._id || index} className="flex justify-between border p-2 rounded bg-gray-50">
                          <span className="break-all max-w-[90%]">{opt.name}</span>
                          <span className="font-bold">{opt.weight}</span>
                        </div>
                      ))}
                    </div>
                </div>
              )}
            </div>
          )}

          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default ViewCategoryModal;
